export default [
    '$rootScope',
    'SPClientData',
    function userStateFacade($rootScope, SPClientData) {
        $rootScope.userState = SPClientData.getInitialUserState();
    }
];
